var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card-content",
    [
      _c(
        "w-row",
        [
          _c("w-col", { attrs: { xs: "12" } }, [
            _vm._v(" Instellingen overzetten "),
          ]),
        ],
        1
      ),
      _vm._l(_vm.moveUserSettings, function (entry, i) {
        return _c(
          "w-row",
          { key: i },
          [
            _c(
              "w-col",
              { attrs: { xs: "6" } },
              [
                _c("w-select", {
                  attrs: {
                    fancy: "",
                    items: _vm.sourceUserItems,
                    label: "Instellingen van gebruiker",
                  },
                  model: {
                    value: entry.fromUserId,
                    callback: function ($$v) {
                      _vm.$set(entry, "fromUserId", $$v)
                    },
                    expression: "entry.fromUserId",
                  },
                }),
              ],
              1
            ),
            _c(
              "w-col",
              { attrs: { xs: "5" } },
              [
                _c("w-select", {
                  attrs: {
                    fancy: "",
                    items: _vm.targetUserItems,
                    label: "overzetten naar gebruiker",
                  },
                  model: {
                    value: entry.toUserId,
                    callback: function ($$v) {
                      _vm.$set(entry, "toUserId", $$v)
                    },
                    expression: "entry.toUserId",
                  },
                }),
              ],
              1
            ),
            _c(
              "w-col",
              { style: { justifyContent: "center" }, attrs: { xs: "1" } },
              [
                _c(
                  "w-button",
                  {
                    attrs: { flat: "" },
                    on: {
                      click: function ($event) {
                        return _vm.removeItem(i)
                      },
                    },
                  },
                  [_c("w-fa", { attrs: { icon: "trash" } })],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      }),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c(
                "w-link",
                { on: { click: _vm.addEntry } },
                [
                  _c("w-fa", { attrs: { icon: "plus" } }),
                  _vm._v(" Gebruiker kopelling toevoegen"),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }